import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptLoaderService {
  private loadedScripts: Set<string> = new Set();

  constructor() {}

  loadScripts(scripts: string[]): Promise<void[]> {
    const promises: Promise<void>[] = [];

    scripts.forEach((scriptUrl) => {
      if (!this.loadedScripts.has(scriptUrl)) {
        promises.push(this.loadScript(scriptUrl));
      }
    });

    return Promise.all(promises);
  }

  private loadScript(scriptUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => {
        this.loadedScripts.add(scriptUrl);
        resolve();
      };
      script.onerror = () => reject(`Failed to load script: ${scriptUrl}`);
      document.body.appendChild(script);
    });
  }
}
